import { Box } from '@breathelife/mui';
import { ReactElement } from 'react';

import { RenderingFieldGroup } from '@zinnia/form-engine-sdk';

import { FieldWrapperB } from '../../../PdfFieldGeneration/FieldVariantB/FieldWrapperB';

type Props = {
  fieldGroups: RenderingFieldGroup[];
};

let questionSequence = 1;
export function FieldGroups(props: Props): ReactElement {
  const { fieldGroups } = props;
  return (
    <div>
      {fieldGroups.map((fieldGroup) => {
        if (!fieldGroup.visible) return null;
        fieldGroup.index = String(questionSequence);
        questionSequence++;
        return (
          <Box key={fieldGroup.id} mb={2}>
            <FieldWrapperB fieldGroup={fieldGroup} />
          </Box>
        );
      })}
    </div>
  );
}
